import { ComponentProps, ReactNode } from 'react';
import { Button, ButtonLink } from '~/modules/Elements/AKUI/Button';
import { InputWrapper } from '~/modules/Elements/AKUI/InputWrapper';

type Props = Omit<ComponentProps<typeof Button> | ComponentProps<typeof ButtonLink>, 'size'> & {
  info?: ReactNode;
  size?: 'regular' | 'small';
};

export const MenuButton = ({ size = 'regular', info, className, ...props }: Props) => {
  const Component = 'href' in props ? ButtonLink : Button;

  // Px (estable) + responsive real
  const heightClass = size === 'small' ? 'h-[46px] sm:h-[50px] md:h-[54px]' : 'h-[52px] sm:h-[58px] md:h-[64px]';

  return (
    <InputWrapper info={info}>
      {/* @ts-expect-error either Button or a link */}
      <Component {...props} data-size={size} className={`${heightClass} w-full ${className ?? ''}`} />
    </InputWrapper>
  );
};
